import { render, staticRenderFns } from "./DatabaseCluster.vue?vue&type=template&id=27ebc584"
import script from "./DatabaseCluster.vue?vue&type=script&lang=js"
export * from "./DatabaseCluster.vue?vue&type=script&lang=js"
import style0 from "./DatabaseCluster.vue?vue&type=style&index=0&id=27ebc584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports